<br />
<mat-card class="card-warning">
  <p>
    <a routerLink="/discente/status-inscricao"
      >Ficou com dúvida <mat-icon class="icon-middle">help</mat-icon><br />Clique aqui e consulte a opção
      <b>Status das inscrições</b>.</a
    >
  </p>
</mat-card>
